import { cn } from "@/lib/utils";
import { Card, Shop } from "@/types/v2";
import { getCardSection } from "@/lib/cards";
import { Loading } from "@/components/Page/Loading";
import { DEFAULT_CARD_LABEL_WRAP } from "@/lib/const";

export interface CardDetailsProps {
  cardData: Card;
  shop: Shop;
  disabled?: boolean;
}

export const CardDetails = ({ cardData, shop, disabled }: CardDetailsProps) => {
  if (!shop) return <Loading />;

  return (
    <div className="flex w-full min-w-0 flex-grow items-center space-y-0.5 px-1">
      <div
        className={cn(
          "m-0 min-h-5 w-full min-w-0 cursor-grab border-none p-0 text-left",
          disabled && "cursor-default"
        )}
      >
        <div className="flex w-full min-w-0 flex-row justify-between">
          <div className="w-full min-w-0 pr-3">
            <p
              className={cn(
                "card-text mb-[4px] mt-[-3px] overflow-hidden text-xs/[14px]",
                // Wrap off: one ellipsized line. Wrap on: up to two lines, still
                // bounded so a long label cannot overflow the card.
                (shop?.cardLabelWrap ?? DEFAULT_CARD_LABEL_WRAP) === "no"
                  ? "truncate text-nowrap"
                  : "line-clamp-2"
              )}
            >
              <span>{getCardSection(cardData, shop, "secondaryField")}</span>
            </p>

            <p
              className={cn(
                "card-text mb-[4px] mt-[-3px] overflow-hidden text-xs/[14px] opacity-60",
                (shop?.cardLabelWrap ?? DEFAULT_CARD_LABEL_WRAP) === "no"
                  ? "truncate text-nowrap"
                  : "line-clamp-2"
              )}
            >
              {getCardSection(cardData, shop, "tertiaryField")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
